import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { HomeComponent } from './home/home.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { LoginComponent } from './auth/login/login.component';
import { LayoutComponent } from './layout/layout.component';
import { LibdashComponent } from './libdash/libdash.component';
import { BooksComponent } from './books/books.component';
import { MembersComponent } from './members/members.component';
//import { LibcategoryComponent } from './libmasters/libcategory/libcategory.component';
import { LibmasterComponent } from './libmasters/libmasters.component';
import { BookissueComponent } from './bookissue/bookissue.component';
import { VisitrecordComponent } from './visitrecord/visitrecord.component';
import { EnquiryComponent,AdmissionComponent,PgenquiryComponent,SmsComponent } from './frontoffice/index';
import { AstmstrComponent,ItemmstrComponent,AsetmastersComponent ,ItemqrcodeComponent} from './inventory/index';
import { StuallotComponent,AssignactComponent } from './mentor/index';
import { AcademicmasComponent,CurriculammasComponent,AcfeechartComponent,AccmasterComponent,AssessmentComponent } from './masters/index';
import { FeedmasterComponent } from './feedback/feedmaster/feedmaster.component';
import { FbqttypemasComponent } from './feedback/fbqttypemas/fbqttypemas.component';
import { FbqtbankComponent } from './feedback/fbqtbank/fbqtbank.component';
import { FeedbackprevComponent } from './feedback/feedbackprev/feedbackprev.component';
import { AttperiodComponent,AttsessionComponent,AttpertimeComponent,AttreportComponent } from './attendance/index';
import { AcreceiptComponent } from './feecounter/acreceipt/acreceipt.component';
import { AssignmentComponent } from './classroom/assignment/assignment.component';
//import { AttsessionComponent } from './attendance/attsession/attsession.component';
import { LibperiodicalsComponent } from './libperiodicals/libperiodicals.component';
import { ElinksComponent } from './elinks/elinks.component';
import {AssessmentschComponent,HolidaysComponent,YearCalenderComponent,TimetableComponent,SmsmarksComponent} from './schedules/index';
import { MarkssubComponent ,MarksstuComponent,LabvisitComponent,WorksheetComponent,EventgallaryComponent} from './classroom/index';
import { StockauditComponent } from './stockaudit/stockaudit.component';
import {BookresvComponent,ReferredbooksComponent,EbooksComponent,OpacComponent,BookindentComponent,AprvindentComponent,CirculationComponent,LibmembersComponent  } from './library/index';
import { HrmastersComponent } from './hrms/hrmasters/hrmasters.component';
import { OccationsComponent } from './schedules/occations/occations.component';
import { NotificationsComponent } from './schedules/notifications/notifications.component';
import { RolesComponent } from './security/roles/roles.component';
import { LogsComponent } from './security/logs/logs.component';
import { CandidateComponent,PostsComponent,CompanyComponent,PladashComponent,InsjobpostComponent,PlanotificationsComponent } from './placement/index';
import { EmploysComponent } from './hrms/employs/employs.component';
import { EvpatternComponent } from './evaluation/evpattern/evpattern.component';
import { MarksgenComponent } from './classroom/marksgen/marksgen.component';
import { RoomallocationComponent } from './evaluation/roomallocation/roomallocation.component';
import { UsersComponent } from './security/users/users.component';
import { ReportcardComponent } from './evaluation/reportcard/reportcard.component';
import { AdmitcardComponent } from './evaluation/admitcard/admitcard.component';
import { WorkdairyComponent } from './hrms/workdairy/workdairy.component';
import { GeneratefeesComponent } from './feecounter/generatefees/generatefees.component';
import { ResourcesComponent } from './classroom/resources/resources.component';
import { EvlmasterComponent } from './evaluation/evlmaster/evlmaster.component';
import { ResultsComponent } from './evaluation/results/results.component';
import { QuestionbankComponent } from './evaluation/questionbank/questionbank.component';
import { QuestpaperComponent } from './evaluation/questpaper/questpaper.component';
import { QpallotmentComponent } from './evaluation/qpallotment/qpallotment.component';
import { RemarkentryComponent } from './classroom/remarkentry/remarkentry.component';
import { VtcandidateComponent } from './voting/candidate/candidate.component';
import { VotersComponent } from './voting/voters/voters.component';
//import { SmsComponent } from './schedules/sms/sms.component';
const routes: Routes = [
  {path: '',  redirectTo: 'login', pathMatch: 'full' } ,
  { path: 'login', component: LoginComponent },

  {
    path: 'app', component: LayoutComponent,
    children: [
      { path: 'home', component: HomeComponent },
      {path: '', redirectTo: 'home', pathMatch: 'full'},
      { path: 'dash', component: DashboardComponent  } ,
      { path: 'Dashboard', component: AstmstrComponent  } ,
      { path: 'libdash', component: LibdashComponent  },
      { path: 'books', component: BooksComponent  },
      { path: 'members', component: MembersComponent  },
      { path: 'libmasters', component: LibmasterComponent  },
      { path: 'circulation', component: BookissueComponent  },
      { path: 'visitrecord', component: VisitrecordComponent  },
      { path: 'enquiry', component: EnquiryComponent  },
      { path: 'student', component: AdmissionComponent  },
      { path: 'masteracd', component: AcademicmasComponent  },
      { path: 'mastercur', component: CurriculammasComponent  },
      { path: 'stuallot', component: StuallotComponent  },
      { path: 'stuact', component: AssignactComponent  },
      { path: 'fedmodel', component: FeedmasterComponent  },
      { path: 'qstbank', component: FbqtbankComponent  },
      { path: 'qstype', component: FbqttypemasComponent  },
      { path: 'assch', component: AssessmentschComponent  },
      { path: 'holidays', component: HolidaysComponent  },
      { path: 'yrcalender', component: YearCalenderComponent  },
      { path: 'fdprev', component: FeedbackprevComponent  },
      { path: 'attper', component: AttpertimeComponent  },
      { path: 'attses', component: AttsessionComponent  },
      { path: 'periodicals', component: LibperiodicalsComponent  },
      { path: 'assetmasters', component: AsetmastersComponent  },
      { path: 'invitem', component: ItemmstrComponent  },
      { path: 'invqritem', component: ItemqrcodeComponent  },
      { path: 'invasset', component: AstmstrComponent  },
      { path: 'elvsubject', component: MarkssubComponent  },
      { path: 'marksdetail', component: MarksstuComponent  },
      { path: 'acreceipt', component: AcreceiptComponent  },
      { path: 'stockaudit', component: StockauditComponent  },
      { path: 'lbread', component: ReferredbooksComponent  },
      { path: 'lbrequest', component: BookresvComponent  },
      { path: 'libebooks', component: ElinksComponent  },
      { path: 'labvisit', component: LabvisitComponent  },
      { path: 'hrmaster', component: HrmastersComponent  },
      //{ path: 'hrmaster', component: HrmastersComponent  },
      { path: 'occation', component: OccationsComponent  },
      { path: 'notification', component: NotificationsComponent  },
      { path: 'bkindent', component: BookindentComponent  },
        // { path: 'sms', component: SmsComponent  },
      { path: 'opac', component: OpacComponent  },
      { path: 'acfeechart', component: AcfeechartComponent  },
      { path: 'accmasters', component: AccmasterComponent  },
      { path: 'authindent', component: AprvindentComponent  },
      { path: 'roles', component: RolesComponent  },
      { path: 'logs', component: LogsComponent  },
      { path: 'plcandidates', component: CandidateComponent  },
      { path: 'jobposts', component: PostsComponent  },
      { path: 'company', component: CompanyComponent  },
      { path: 'staff', component: EmploysComponent  },
      { path: 'pladash', component: PladashComponent  },
      { path: 'bkcirculation', component: CirculationComponent  },
      { path: 'libmember', component: LibmembersComponent  },
      { path: 'insjobs', component: InsjobpostComponent  },
      { path: 'asmas', component: AssessmentComponent  },
      { path: 'evpattern', component: EvpatternComponent  },
      { path: 'schtime', component: TimetableComponent  },
      { path: 'assignment', component: AssignmentComponent  },
      { path: 'enableevaluation', component: MarksgenComponent  },
      {path:'attreports',component:AttreportComponent},
      {path:'sms',component:SmsmarksComponent},
      {path:'rmalocation',component:RoomallocationComponent},
      {path:'users',component:UsersComponent},
      {path:'reportcard',component:ReportcardComponent},
      {path:'admitcard',component:AdmitcardComponent},
      {path:'wrkdairy',component:WorkdairyComponent},
      {path:'genfees',component:GeneratefeesComponent},
      {path:'resources',component:ResourcesComponent},
      {path:'worksheet',component:WorksheetComponent},
      {path:'eventgallery',component:EventgallaryComponent},
      {path:'evlmaster',component:EvlmasterComponent},
      {path:'ugresults',component:ResultsComponent},
      {path:'questbank',component:QuestionbankComponent},
      {path:'questpaper',component:QuestpaperComponent},
      {path:'ceschedule',component:QpallotmentComponent},
      {path:'rmkentry',component:RemarkentryComponent},
      {path:'vtcandidates',component:VtcandidateComponent},
      {path:'voters',component:VotersComponent},
    ]}
];





@NgModule({
  imports: [RouterModule.forRoot(routes,{ useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
